import React, { FunctionComponent } from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { connect } from 'react-redux';
import Sizes from '../../../sizes';
import Theme from '../../../theme';
import { defaultScale, scaledRatio } from '../../../utils/scaling';
import { IAppStore } from '../../reducer';
import { preLoadPercentCompleteSelector} from '../../selectors';

interface IProps {
    loadingPercent: number | null;
    t(key: string, options?: any): string;
}

export const PreWorkoutProgressLoadingComponent: FunctionComponent<IProps> = ({
                                                                          loadingPercent,
                                                                          t,
                                                                        }) => {
  return (
    <View style={styles.loadingContainer}>
        <View style={{...styles.loadingBar, backgroundColor: Theme.PRIMARY,
        width:  loadingPercent ?  loadingPercent + '%' : '1%'}}>
        </View>
        <Text style={styles.loadingText}>
        {t('loadingWorkoutText') + (loadingPercent != null ? ` ${loadingPercent}%` : '')}
        </Text>
  </View>
  );
};

const mapStateToProps = (state: IAppStore): Partial<IProps> => {
  return {
    loadingPercent: preLoadPercentCompleteSelector(state),
  };
};

export const PreWorkoutProgressLoading =
  translate(['bookings'])(connect(mapStateToProps)(PreWorkoutProgressLoadingComponent));

const styles = StyleSheet.create({
    loadingBar: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
      loadingText: {
        ...Theme.textStyle.bodyCopyBold,
        paddingLeft: scaledRatio(60, 2.5),
      },
      loadingContainer: {
        flex: 1,
        justifyContent: 'flex-start',
        backgroundColor: Theme.GREY_LIGHT,
        height: defaultScale(Sizes.ButtonMedium),
        borderRadius: 2,
        alignItems: 'center',
        flexDirection: 'row',
      },
});
